import { useQuery, useQueryClient } from "react-query";
import { processOAuthSuccess } from "src/welcome/data-access/gateway";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useAuth } from "src/shared/context/useAuth";
import { useNavigate } from "react-router-dom";
import { OAuthModes } from "src/welcome/types";
import DangerouslySetHtmlContent from "dangerously-set-html-content";
import React from "react";
import { USER_DATA_INFO_QUERY_KEY } from "src/shared/enums/useQueryKeys";

export const useProcessOAuthSuccess = (enabled: boolean) => {
  const { t } = useTranslation();
  const { userHomePath } = useAuth();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ["processOAuthSuccess"],
    queryFn: processOAuthSuccess,
    enabled: enabled,
    retry: false,
    onSuccess: async (data) => {
      switch (data?.data?.mode) {
        case OAuthModes.LOGOUT_REMINDER:
          navigate("/welcome/resetPasswordForm", {
            state: {
              m01Id: data.data.m01Id,
              m01UserName: data.data.m01UserName,
            },
          });
          break;
        case OAuthModes.LOGOUT_REGISTRATION:
          navigate("/welcome/registrationForm", {
            state: { bid: data?.data?.bid },
          });
          break;
        case OAuthModes.LOGOUT_COMPLAINT:
          navigate("/complaint/form");
          break;
        case OAuthModes.LOGOUT_COMPANY_NAME_APPROVER:
          await queryClient.invalidateQueries({
            queryKey: [USER_DATA_INFO_QUERY_KEY],
            exact: false,
          });
          navigate("/namePurchase/approverRequestView");
          break;
        case OAuthModes.LOGOUT_DIRECT_PURCHASE:
          navigate("/namePurchase/directPurchaseUserForm", {
            state: { afm: data?.data?.afm },
          });
          break;
        case OAuthModes.LOGOUT_NAME_PURCHASE_USE:
          navigate("/namePurchase/usePurchaseForm", {
            state: { afm: data?.data?.afm },
          });
          break;
        case OAuthModes.LOGOUT_CANCEL_NAME_TITLE_APP:
          return;
      }
    },
    onError: (error: any) => {
      if (error?.response?.data?.mode) {
        enqueueSnackbar(
          error?.response?.data?.message
            ? t(error?.response?.data?.message)
            : t(
                "Συνέβη κάποιο σφάλμα συστήματος, παρακαλούμε προσπαθήστε ξανά αργότερα.",
              ),
          { variant: "error" },
        );
      } else {
        enqueueSnackbar(
          <div>
            {error?.response?.data ? (
              <DangerouslySetHtmlContent html={error?.response?.data} />
            ) : (
              t(
                "Συνέβη κάποιο σφάλμα συστήματος, παρακαλούμε προσπαθήστε ξανά αργότερα.",
              )
            )}
          </div>,
          { variant: "error" },
        );
      }
      switch (error?.response?.data?.mode) {
        case OAuthModes.LOGOUT_DIRECT_PURCHASE:
          navigate("/namePurchase/directPurchase");
          break;
        case OAuthModes.LOGOUT_NAME_PURCHASE_USE:
          navigate("/namePurchase/usePurchase");
          break;
        case OAuthModes.LOGOUT_CANCEL_NAME_TITLE_APP:
          navigate("/namePurchase/companyNames");
          break;
        default:
          navigate(userHomePath);
          break;
      }
    },
  });
};
